module.exports = __webpack_public_path__ + "images/emoji/kiss.3b18faef261e18aea69b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/kiss.png
// module id = ki5O
// module chunks = 24